var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclipAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9816 8.04146L8.46859 15.5545C6.76005 17.263 3.98995 17.263 2.28141 15.5545C0.572864 13.8459 0.572864 11.0758 2.28141 9.36728L9.79442 1.85427C10.9334 0.715243 12.7802 0.715243 13.9192 1.85427C15.0582 2.9933 15.0582 4.84003 13.9192 5.97906L6.70082 13.1974C6.13131 13.767 5.20794 13.767 4.63843 13.1974C4.06892 12.6279 4.06892 11.7046 4.63843 11.135L10.9729 4.80055",
    stroke: "#374562",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipAttach);
export default __webpack_public_path__ + "static/media/paperclip-attach.687085ac9bf307ec9726e85b6a3eb507.svg";
export { ForwardRef as ReactComponent };